import Grid from "@mui/material/Grid2";
import { FormGroup } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { DataFormat } from "utils";
import { Fragment, ReactNode } from "react";
import { CalculationMethodDetailsByTypeProps } from "@schemas/calculationmethods/schema";

type DetailsField = {
	id: string;
	render: () => ReactNode;
}

const QuantityUnitCalculationMethodDetails = ({ calculationMethod, currency, session, hiddenFields }: CalculationMethodDetailsByTypeProps) => {
	const QuantityUnitCalculationMethodDetailsFields: DetailsField[] = [
		{
			id: "calculationMethod.price",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: `PRICE_PER_${calculationMethod.quantityUnit}` })} overflow="hidden">
						{DataFormat.price(calculationMethod.price, currency.isoCode, session.locale)}
					</FormGroup>
				</Grid>
			),
		},
		{
			id: "calculationMethod.customUnit",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "CONTRACT_UNIT" })} overflow="hidden">
						{calculationMethod.customUnit}
					</FormGroup>
				</Grid>
			),
		},
	];

	return (
		<>
			{QuantityUnitCalculationMethodDetailsFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default QuantityUnitCalculationMethodDetails;
